var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate, useParams } from "react-router";
import { AccountInfo } from "./account.info";
import { PasswordChange } from "./account.password.change";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AccountActivities } from "./account.activities";
import { BankAccounts } from "./account.bank.accounts";
import { NotificationSettings } from "./account.notification.settings";
import { ContactSettings } from "./account.contact.settings";
import { CookieSettings } from "./account.cookie.settings";
import "./account.css";
import { AccountOrderHistory } from "./account.order.history";
import { auth, authSubject } from "../../store/auth.store";
import { useForceUpdate } from "../../services/misc.functions";
import { isMobile } from "../../App";
import paths from "../../paths";
import { AccountSessions } from "./account.sessions";
// import iconLeft from "../../assets/icons/left-arrow.png";
var subPages = {
    "hesap-bilgileri": _jsx(AccountInfo, {}),
    "sifre-degisikligi": _jsx(PasswordChange, {}),
    "hesap-aktiviteleri": _jsx(AccountActivities, {}),
    "banka-hesaplarim": _jsx(BankAccounts, {}),
    "bildirim-tercihlerim": _jsx(NotificationSettings, {}),
    "iletisim-tercihlerim": _jsx(ContactSettings, {}),
    "cerez-ayarlari": _jsx(CookieSettings, {}),
    "islem-gecmisim": _jsx(AccountOrderHistory, {}),
    "oturumlarim": _jsx(AccountSessions, {}),
};
export function Account() {
    var forceUpdate = useForceUpdate();
    var param = useParams();
    var navigate = useNavigate();
    useEffect(function () {
        var _a;
        var auth_subscriber = authSubject.subscribe(function () {
            var _a;
            if (!auth.member || !((_a = auth.member) === null || _a === void 0 ? void 0 : _a.id)) {
                navigate(paths.login.url);
            }
            forceUpdate();
        });
        if (!auth.member || !((_a = auth.member) === null || _a === void 0 ? void 0 : _a.id)) {
            navigate(paths.login.url);
        }
        return function () {
            auth_subscriber.unsubscribe();
        };
    }, []);
    if (param.page && subPages[param.page]) {
        return subPages[param.page];
    }
    return _jsx(_Fragment, {});
}
export function AccountInfoMenu() {
    var pathname = useLocation().pathname;
    var menuItems = [
        {
            path: "hesap-bilgileri",
            label: "Üyelik Bilgilerim",
            shortLabel: "Bilgilerim",
            icon: ""
        },
        {
            path: "sifre-degisikligi",
            label: "Şifre Değişikliği",
            shortLabel: "Şifre Değişikliği",
            icon: ""
        },
        {
            path: "hesap-aktiviteleri",
            label: "Hesap Aktiviteleri",
            shortLabel: "Aktiviteler",
            icon: ""
        },
        {
            path: "banka-hesaplarim",
            label: "Kayıtlı Banka Hesaplarım",
            shortLabel: "Banka Hesaplarım",
            icon: ""
        }
    ];
    return (_jsx("div", __assign({ className: "account-menu-container ".concat(isMobile ? 'account-menu-mobile' : '') }, { children: menuItems.map(function (item, index) {
            var isActive = pathname.includes(item.path);
            var isLast = index === menuItems.length - 1;
            return (_jsxs("div", __assign({ className: "account-menu-item" }, { children: [_jsx("div", { className: "account-menu-item-bg ".concat(isActive ? 'active' : ''), style: { borderBottom: isLast && !isMobile ? 'none' : '1px #F0F1F6 solid' } }), _jsxs(Link, __assign({ to: "".concat(paths.account.url, "/").concat(item.path, "/"), className: "account-menu-link" }, { children: [_jsx("div", __assign({ className: "account-menu-icon" }, { children: _jsx("span", __assign({ style: { fontSize: '16px' } }, { children: item.icon })) })), _jsx("div", __assign({ className: "account-menu-text ".concat(isActive ? 'active' : '') }, { children: isMobile ? item.shortLabel : item.label }))] }))] }), item.path));
        }) })));
}
export function OrderHistoryMenu(_a) {
    var gameSlugs = _a.gameSlugs;
    var pathname = useLocation().pathname;
    return (_jsx("div", __assign({ className: "account-menu-container ".concat(isMobile ? 'account-menu-mobile' : '') }, { children: gameSlugs.map(function (game, index) {
            var isActive = pathname.includes(game.slug);
            var isLast = index === gameSlugs.length - 1;
            return (_jsxs("div", __assign({ className: "account-menu-item" }, { children: [_jsx("div", { className: "account-menu-item-bg ".concat(isActive ? 'active' : ''), style: { borderBottom: isLast && !isMobile ? 'none' : '1px #F0F1F6 solid' } }), _jsxs(Link, __assign({ to: "".concat(paths.account.url, "/islem-gecmisim/").concat(game.slug, "/"), className: "account-menu-link" }, { children: [_jsx("div", __assign({ className: "account-menu-icon" }, { children: _jsx("span", { style: { fontSize: '16px' } }) })), _jsx("div", __assign({ className: "account-menu-text ".concat(isActive ? 'active' : '') }, { children: isMobile ? game.name.substring(0, 8) + (game.name.length > 8 ? '...' : '') : game.name }))] }))] }), game.slug));
        }) })));
}
export function NotificationMenu() {
    var pathname = useLocation().pathname;
    var menuItems = [
        {
            path: "bildirim-tercihlerim",
            label: "Bildirim Tercihlerim",
            shortLabel: "Bildirimler",
            icon: ""
        },
        {
            path: "iletisim-tercihlerim",
            label: "İletişim Tercihlerim",
            shortLabel: "İletişim",
            icon: ""
        },
        {
            path: "cerez-ayarlari",
            label: "Çerez Ayarları",
            shortLabel: "Çerezler",
            icon: ""
        }
    ];
    return (_jsx("div", __assign({ className: "account-menu-container ".concat(isMobile ? 'account-menu-mobile' : '') }, { children: menuItems.map(function (item, index) {
            var isActive = pathname.includes(item.path);
            var isLast = index === menuItems.length - 1;
            return (_jsxs("div", __assign({ className: "account-menu-item" }, { children: [_jsx("div", { className: "account-menu-item-bg ".concat(isActive ? 'active' : ''), style: { borderBottom: isLast && !isMobile ? 'none' : '1px #F0F1F6 solid' } }), _jsxs(Link, __assign({ to: "".concat(paths.account.url, "/").concat(item.path, "/"), className: "account-menu-link" }, { children: [_jsx("div", __assign({ className: "account-menu-icon" }, { children: _jsx("span", __assign({ style: { fontSize: '16px' } }, { children: item.icon })) })), _jsx("div", __assign({ className: "account-menu-text ".concat(isActive ? 'active' : '') }, { children: isMobile ? item.shortLabel : item.label }))] }))] }), item.path));
        }) })));
}
